import { getAccrualCheck } from './accrual-check'
import { sumDecimalAmounts } from './decimal-sum'

type GroupInput = {
  trade_daily_accrual_amount: string | null
  past_5_day_average: string | null
  value_date: string | null
  value_date_tmo: string | null
  instrument_trade_count_3d: number
}

const dates = (values: (string | null)[]) =>
  [...new Set(values.flatMap((value) => (value ?? '—').split(', ')))].sort().join(', ')

/** Sum exact daily/comparison values, then classify the instrument using those totals. */
export const aggregateDailyRows = (rows: readonly GroupInput[]) => {
  const amount = sumDecimalAmounts(rows.map((row) => row.trade_daily_accrual_amount))
  const average = sumDecimalAmounts(rows.map((row) => row.past_5_day_average))
  return {
    trade_daily_accrual_amount: amount,
    past_5_day_average: average,
    accrual_check: getAccrualCheck(amount, average),
    value_date: dates(rows.map((row) => row.value_date)),
    value_date_tmo: dates(rows.map((row) => row.value_date_tmo)),
    instrument_trade_count_3d: rows.reduce((maximum, row) => Math.max(maximum, row.instrument_trade_count_3d), 0),
  }
}
